/***********************/
/* Angular + external */
import { Component, ElementRef, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject, Subscription } from "rxjs";
/***********************/
/* BFX */
// models
import { BfxDialogData } from "./models/bfx-dialog-data.model";
// components
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
// services
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxTradeDialogsProcessorService } from "./services/bfx-trade-dialogs-processor.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxConfigIDRefHelper } from "../../shared/helper-services/bfx-config-id-ref-helper";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: `bfx-dialog-trade-cancel-confirm`,
  templateUrl: `./html/bfx-dialog-trade-cancel-confirm.html`,
  standalone: false,
})
export class BfxDialogTradeCancelConfirmComponent
  extends BfxDialogBaseComponent
  implements OnDestroy
{
  /***************************************/
  /* DATA */
  public config: any = {
    debug: false,
  };

  public data = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    txt_title: null,
    txt_message: null,
    txt_sub_message: null,
    txt_sub_ids: null,
    showIds: false,

    dialogData: {
      show: false,
      width: 450,
    },
  };

  private configurationSubscription: Subscription;

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    private _configService: BfxConfigService,
    private _translationService: TranslateService,
    private _tradeDialogProcessorService: BfxTradeDialogsProcessorService,
    private _element: ElementRef,
  ) {
    super();
    this.subscribeToConfiguration();
  }

  ngOnDestroy() {
    this.configurationSubscription.unsubscribe();
  }

  /**********************************************************************/
  /* INITIALIZATION */
  private subscribeToConfiguration(): void {
    this.configurationSubscription = this._configService.uiConfig$.subscribe((config) => {
      this.config.debug = config.general.debug;
    });
  }

  /**********************************************************************/
  /* CANCEL TRADE CONFIRM - Open/Close Dialog */
  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;
      let event = this.data.actionEvent;

      if (
        event !== null &&
        event !== undefined &&
        Array.isArray(event.selectedItems) &&
        event.selectedIds.length > 0
      ) {
        // init
        let dealRefs: Array<string> = event.selectedItems.map((item) =>
          BfxConfigIDRefHelper.getDealRef(item),
        );
        // title & notice
        this.data.txt_title = this._translationService.instant("trade.cancel.title");
        this.data.txt_message = this._translationService.instant("trade.cancel.message");
        // derive message
        if (dealRefs.length === 1) {
          this.data.showIds = false;
          this.data.txt_sub_message = this._translationService.instant(
            "trade.cancel.sub_message.single",
          );
        } else if (dealRefs.length > 1) {
          this.data.showIds = true;
          this.data.txt_sub_message = this._translationService.instant(
            "trade.cancel.sub_message.multi",
            [dealRefs.length],
          );
          this.data.txt_sub_ids = dealRefs.join(",\n");
        }

        // show the dialog
        NativeDesktopSupport.prepareEmbeddedDialog(_dialogData.body, this._dialog, this._element);

        this.data.dialogData.show = true;
      } else {
        logger.out.error(
          "ERROR: BfxDialogTradeCancelComponent.openDialog(): Invalid event data",
          _dialogData,
        );
      }
    } catch (ex) {
      logger.out.error(
        "ERROR: BfxDialogTradeCancelComponent.openDialog(): Dialog exception! msg:",
        ex,
      );
    }
    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    super.closeDialog();

    this.data.txt_title = null;
    this.data.txt_message = null;
    this.data.txt_sub_message = null;
    this.data.txt_sub_ids = null;
    this.data.showIds = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  /**********************************************************************/
  /* CANCEL TRADE CONFIRM - Actions */
  public actionCancelTrade_yes(): void {
    if (this.data.actionEvent != null) {
      this._tradeDialogProcessorService.executeCancelTrade(this.data.actionEvent);
    } else {
      logger.out.error(
        "ERROR: BfxDialogTradeCancelComponent.actionCancelTrade_yes(): Could not cancel trades, action event is null!",
      );
    }
    this.closeDialog();
  }

  public actionCancelTrade_no(): void {
    this.closeDialog();
  }
}
